module.exports = __webpack_public_path__ + "img/error_bg_1x.e45406d7.png";